export type HomeViewId = "visao-geral" | "obras-em-andamento";

export interface HomeViewDefinition {
  id: HomeViewId;
  label: string;
  testId: string;
}

/**
 * AC2 — a Tela Inicial oferece exatamente estas duas visões. "Obras Futuras" e
 * "Obras Finalizadas" aparecem no protótipo, mas seguem em backlog e não são
 * exibidas nem oferecidas como opção (RN05/RN06).
 */
export const HOME_VIEWS: HomeViewDefinition[] = [
  { id: "visao-geral", label: "Visão Geral", testId: "home-view-visao-geral" },
  {
    id: "obras-em-andamento",
    label: "Obras em Andamento",
    testId: "home-view-obras-em-andamento",
  },
];

export const HOME_DEFAULT_VIEW: HomeViewId = "visao-geral";

/** RN07 do 1473: no mobile só existe Obras em Andamento. */
export const HOME_NARROW_VIEW: HomeViewId = "obras-em-andamento";

/**
 * Ponto de quebra do protótipo responsivo, o mesmo do layout autenticado
 * (`layout.module.scss`). Até 768px, inclusive, só aparece Obras em Andamento;
 * a Visão Geral e a barra de abas existem apenas acima dele.
 */
export const HOME_NARROW_QUERY = "(max-width: 768px)";
